<template>
    <div>
        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in videos" :key="v.id">
                <a class="video-lists-link" :href="`/videos/${v.id}`" :title="v.title" target="_blank">
                    <div class="pr">
                        <i class="icon-play"></i>
                        <img class="video-thumb" v-lazy="v.thumb">
                        <div class="video-mask"></div>
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`舞蹈风格: ${v.cate}`">{{v.cate}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                            <span class="video-comments" :title="`上传时间: ${v.addtime}`">
                                <i class="icon-clock"></i> {{$time(v.addtime)}}
                            </span>
                        </p>
                    </div>
                </a>
            </li>
        </ul>

        <el-pagination v-if="videos.length && videoTotal > 40" :current-page="page"  @current-change="currentChange" :page-size="40" :total="videoTotal" background layout="total, prev, pager, next"></el-pagination>
    </div>
</template>

<script>
    export default {
        props: {
            videoTotal: Number,
        },
        data: () => ({
            videos: [],
            total: 0,
        }),
        computed: {
            id () {
                return +this.$route.params.id || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            },
        },
        methods: {
            currentChange(page) {
                this.$router.push(`?page=${page}`);
            },
        },
        beforeMount() {
            this.api.get(`studios/${this.id}/videos`, {page: this.page}).then(e => this.videos = e, this.err);
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            let {page} = to.query;
            page = +page || 1;
            this.api.get(`studios/${this.id}/videos`, {page}).then(e => this.videos = e, this.err);
            next();
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";
</style>


// WEBPACK FOOTER //
// src/views/studio/Video.vue